import _DialogContent from "@mui/material/DialogContent";
import _Send from "@mui/icons-material/Send";
import _CircularProgress from "@mui/material/CircularProgress";
import _Close from "@mui/icons-material/Close";
import _TextField from "@mui/material/TextField";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Dialog2 from "@mui/material/Dialog";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GeogroupService } from '../services';
import { Button as CustomButton } from './button';
export function ContactDialog({
  Dialog: _Dialog,
  Button: _Button,
  currentUser,
  challenge,
  selectedUsersIds,
  onClose,
  ...props
}) {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  useEffect(() => {
    setMessage('');
  }, [props.open]);
  async function handleContact() {
    if (!currentUser || !challenge || !message) return;
    setSending(true);
    try {
      await GeogroupService.sendEmailToParticipants(challenge.id, currentUser.email, selectedUsersIds, message);
      onClose();
      enqueueSnackbar(t('commons.challenge_details.contact_dialog.success'));
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('commons.challenge_details.contact_dialog.server_error'), {
        variant: 'error'
      });
    }
    setSending(false);
  }
  const Dialog = _Dialog || _Dialog2;
  const Button = _Button || CustomButton;
  return /*#__PURE__*/React.createElement(Dialog, _extends({
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => onClose()
  }, props), /*#__PURE__*/React.createElement(_DialogContent, {
    sx: _Dialog ? {
      padding: 0
    } : {}
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontSize: "1.1rem",
    fontWeight: 600
  }, t('commons.challenge_details.contact_dialog.title'))), /*#__PURE__*/React.createElement(_TextField, {
    fullWidth: true,
    multiline: true,
    required: true,
    disabled: sending,
    id: "message",
    label: t('commons.challenge_details.contact_dialog.labels_message'),
    margin: "none",
    name: "message",
    onChange: ({
      currentTarget: {
        value
      }
    }) => setMessage(value),
    rows: 2,
    slotProps: {
      htmlInput: {
        maxLength: 500
      }
    },
    value: message,
    variant: "outlined"
  }), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 3,
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    disabled: sending,
    onClick: onClose,
    startIcon: /*#__PURE__*/React.createElement(_Close, null),
    variant: "outlined"
  }, t('commons.actions.cancel')), /*#__PURE__*/React.createElement(Button, {
    disabled: sending || !message,
    onClick: handleContact,
    startIcon: sending ? /*#__PURE__*/React.createElement(_CircularProgress, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/React.createElement(_Send, null),
    variant: "contained"
  }, t('commons.actions.send'))))));
}